import { Flash } from 'AWS-UI-Components-React';
import React from 'react';

export class ErrorFlash extends React.Component {
  render() {
    return (
      <Flash dismissible={true} type="error">
        {`Error fetching ${this.props.type}, retry the request. Contact us if the error persists. PI Tools dev team has been notified via ticket:`}
        <a href={'https://tiny.amazon.com/11ia80cg5'} target="_blank">
          Ticket Queue
        </a>
      </Flash>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/content/error_flash.jsx